// hu-HU
export default {
	title: "Ajándék Kártya Központ",
	myPoints: "Saját pontjaim",
	SelectedGifts: "Kiválasztott ajándékok",
	form: {
		label: {
			title: "Keresés",
			points: "Pontok"
		}
	},
	redemption: "Megváltás",
	stock: "Készlet",
	id: {
		redeemPoints: "Váltson be szükséges pontokat:",
		btn: "Most beváltás",
		title: "Vásárlási értesítés",
		content: `Kedves Dolgozó! Köszönjük, hogy részt vett a munkában.\n\nKérjük, olvassa el az alábbi feltételeket a pontok beváltása előtt:\n\n[Munkapontok] A rendeléskészlet adatoptimalizálásának napi elvégzése után a dolgozók 1 ajándékpontot kaphatnak, amely részleges ajándék-szponzorált beváltásra használható fel.\n[Ajándék beváltása] A dolgozóknak meg kell adniuk a megfelelő szállítási címet, és az ajándékot 14 napon belül ingyenesen kiszállítják világszerte. A beváltás befejezése után kapcsolatba léphet az ügyfélszolgálattal, hogy megkapja a nyomkövetési számot, hogy nyomon kövesse az ajándék folyamatát. A platform nem ad ki információkat harmadik feleknek.\nMegjegyzés: Miután a pontokat ajándékra váltották be, nem téríthetők vissza`
	},
	applyDialog: {
		title: "Információ fogadása",
		form: {
			consignee: "Címzett",
			area: "Terület",
			telephone: "Telefon",
			deliveryAddress: "Szállítási cím"
		},
		btn: "Küldés"
	},
	records: {
		title: "Feljegyzések",
		status: ["Várakozás a szállításra", "Kiszállított", "Kézbesített", "Törölve"]
	}
};
